import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeys, usePatronSession } from '@app/hooks';
import { makeRequest } from '@app/utils';

interface UseSaveInstanceMutationProps {
  savedInstances: { instanceId: string }[];
}

export const useSaveInstanceMutation = () => {
  const { externalSystemId = '' } = usePatronSession();
  const url = `/opac-patron/account/${externalSystemId}/saved-instances`;
  const queryClient = useQueryClient();

  return useMutation(
    ({ savedInstances }: UseSaveInstanceMutationProps) =>
      makeRequest({
        url,
        method: 'POST',
        data: savedInstances,
      }),
    {
      onSuccess: () => {
        queryClient.refetchQueries({
          queryKey: [queryKeys.savedInstancesCompact],
          exact: false,
          type: 'active',
        });
      },
    }
  );
};

export const useUnsaveInstanceMutation = () => {
  const { externalSystemId = '' } = usePatronSession();
  const url = `/opac-patron/account/${externalSystemId}/saved-instances`;
  const queryClient = useQueryClient();

  return useMutation(
    ({ savedInstances }: { savedInstances: string[] }) =>
      makeRequest({
        url,
        method: 'DELETE',
        data: {
          params: {
            savedInstanceIds: savedInstances.join(','),
          },
        },
      }),
    {
      onSuccess: () => {
        queryClient.refetchQueries({
          queryKey: [queryKeys.savedInstancesCompact],
          exact: false,
          type: 'active',
        });
      },
    }
  );
};
